/* Publish by EComposer at 2024-06-28 16:19:08*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-yy23vgiftk"]=  window.__ectimmers["ecom-yy23vgiftk"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-yy23vgiftk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yy23vgiftk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8z0m8wa1xho').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8z0m8wa1xho', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gq11l33lknu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gq11l33lknu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yf2j0yz3ya').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yf2j0yz3ya', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7uqy4lnivr9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7uqy4lnivr9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v2m0r4p2xk8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v2m0r4p2xk8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7ssc4d6myq5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7ssc4d6myq5', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-gmzmz8n6bh"]=  window.__ectimmers["ecom-gmzmz8n6bh"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-gmzmz8n6bh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gmzmz8n6bh', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-4hgu73v8roo"]=  window.__ectimmers["ecom-4hgu73v8roo"] || {};
const e=this.$el;if(!e)return;const i=e.querySelector("form");let t=this.settings.link_redirect;if(this.isLive){(function(){if(!t)return!1;let c=t.href;if(c=="")return!1;let u=t.target;window.location.href.includes("customer_posted=true")&&(u==="_blank"?window.open(c):window.location.href=c)})();const s=/^(\?|&)contact%5Btags%5D=[^&]+&form_type=customer(&|$)/;this.settings.scroll_in_view&&(window.location.pathname.includes("challenge")?setTimeout(function(){var c=document.querySelector(".shopify-challenge__container");c.scrollIntoView()},100):setTimeout(function(){(s.test(location.search)||window.location.href.includes("customer_posted=true"))&&e.scrollIntoView()},300)),s.test(location.search)&&i&&i.querySelector(".ecom-shopify__newsletter-form-message.ecom-dn")&&i.querySelector(".ecom-shopify__newsletter-form-message.ecom-dn").classList.remove("ecom-dn"),i&&i.dataset.ecTrackingId&&i.addEventListener("submit",function(){window.Shopify&&window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:i.id,tracking_id:i.dataset.ecTrackingId})},{once:!0});let o=e.querySelector(".ecom-shopify__newsletter__verify-checkbox"),a=e.querySelector(".ecom-shopify__newsletter__verify-error"),r=e.querySelector(".ecome-shopify__newsletter__button");o&&(r.addEventListener("click",function(c){o.checked==!1?(c.preventDefault(),a.classList.remove("ecom-dn")):a.classList.add("ecom-dn")}),o.addEventListener("change",function(c){o.checked&&a.classList.add("ecom-dn")}))}

                    });
                    
                        document.querySelectorAll('.ecom-4hgu73v8roo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4hgu73v8roo', settings: {"scroll_in_view":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-y6931pd04x"]=  window.__ectimmers["ecom-y6931pd04x"] || {};
var e=this.$el;if(e&&this.isLive){var o=e.querySelectorAll(".element-social-link:not(.element-social-link__custom)");o.length&&o.forEach(function(s){var n=s.getAttribute("href")||"#",r=n.replace("{current-link}",location.href);s.setAttribute("href",r)})}

                    });
                    
                        document.querySelectorAll('.ecom-y6931pd04x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y6931pd04x', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}